import { NgModule, inject } from '@angular/core';
import { ActivatedRouteSnapshot, PreloadAllModules, RouterModule, Routes } from '@angular/router';
// Services
import { AuthService } from '@services/auth/auth.service';
import { PaymentService } from '@services/payment/payment.service';

const routes: Routes = [
	{ 
		path: 'login', 
		loadChildren: () => import('./pages/login/login.module').then(module => module.LoginModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'home', 
		loadChildren: () => import('./pages/home/home.module').then(module => module.HomeModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'account', 
		loadChildren: () => import('./pages/account/account.module').then(module => module.AccountModule) ,
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'groups', 
		loadChildren: () => import('./pages/groups/groups.module').then(module => module.GroupsModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'group-users', 
		loadChildren: () => import('./pages/group-users/group-users.module').then(module => module.GroupUsersModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'users', 
		loadChildren: () => import('./pages/users/users.module').then(module => module.UsersModule) ,
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'task-move', 
		loadChildren: () => import('./pages/task-move/task-move.module').then(module => module.TaskMoveModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'credit-card-payment', 
		loadChildren: () => import('./pages/credit-card-payment/credit-card-payment.module').then(module => module.CreditCardPaymentModule),
		canActivate: [
			(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route),
			() => inject(PaymentService).checkRestrictionAccess(true)
		]
	},
	{ 
		path: 'stripe-payment', 
		loadChildren: () => import('./pages/stripe-payment/stripe-payment.module').then(module => module.StripePaymentModule),
		canActivate: [
			(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route),
			() => inject(PaymentService).checkRestrictionAccess(true)
		]
	},
	{
		path: 'paywall',
		loadChildren: () => import('./pages/paywall/paywall.module').then(module => module.PaywallModule),
		canActivate: [
			(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route),
			() => inject(PaymentService).checkRestrictionAccess(true)
		]
	},
	{ 
		path: 'support-logs', 
		loadChildren: () => import('./pages/support-logs/support-logs.module').then(module => module.SupportLogsModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'onboard', 
		loadChildren: () => import('./pages/onboard/onboard.module').then(module => module.OnboardModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'analytics', 
		loadChildren: () => import('./pages/analytics/analytics.module').then(module => module.AnalyticsModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'security-dashboard', 
		loadChildren: () => import('./pages/security-dashboard/security-dashboard.module').then(module => module.SecurityDashboardModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'account-dashboard', 
		loadChildren: () => import('./pages/account-dashboard/account-dashboard.module').then(module => module.AccountDashboardModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'guestline', 
		loadChildren: () => import('./pages/guestline/guestline.module').then(module => module.GuestlineModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'cs-dashboard', 
		loadChildren: () => import('./pages/cs-dashboard/cs-dashboard.module').then(module => module.CsDashboardModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'marketing-popup', 
		loadChildren: () => import('./pages/marketing-popup/marketing-popup.module').then(module => module.MarketingPopupModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)] 
	},
	{ 
		path: 'qr-management', 
		loadChildren: () => import('./pages/qr-management/qr-management.module').then(module => module.QrManagementModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'organization-mapping', 
		loadChildren: () => import('./pages/org-mapping/org-mapping.module').then(module => module.OrgMappingModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'hubspot-deals', 
		loadChildren: () => import('./pages/invoices/invoices.module').then(module => module.InvoicesModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ 
		path: 'survey', 
		loadChildren: () => import('./pages/survey/survey.module').then(module => module.SurveyModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{
		path: 'sms-email-delivery',
		loadChildren: () => import('./pages/sms-email-delivery/sms-email-delivery.module').then(module => module.SmsEmailDeliveryModule),
		canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthService).canActivate(route)]
	},
	{ path: 'error-page/:code', loadChildren: () => import('./pages/error-page/error-page.module').then(module => module.ErrorPageModule) },
	{
		path: '**',
		redirectTo: 'home'
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {
		preloadingStrategy: PreloadAllModules,
		bindToComponentInputs: true 
	})],
	exports: [RouterModule]
})
export class AppRoutingModule { }